<template>
  <div v-resize="checkMobile" class="day-plan" :class="{ 'day-plan--dark': $vuetify.theme.dark }"
    data-testid="timeline-calendar-page">
    <plan-gate service="day_plan" />
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-toolbar v-if="!isMobile" flat class="day-plan__toolbar start-tour-timeline-1">
      <h2>{{ $t("custom.day_plan") }}</h2>
      <!-- Date select -->
      <v-row align="center" class="ml-2 d-flex align-start">
        <v-menu v-model="date_menu" offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-bind="attrs" v-on="on" readonly :dense="isMobile" v-model="sort_date_for_input"
              prepend-icon="mdi-calendar-clock" style="max-width: 240px" :label="$t('custom.bookings_for_day')"
              data-testid="timeline-date"
              single-line hide-details></v-text-field>
          </template>
          <vc-date-picker v-model="sort_date" mode="date" :min-date="new Date()" :attributes="attrs_calendar"
            :masks="{ input: 'DD-MM-YYYY' }" :locale="$i18n.locale" @input="date_menu = false">
          </vc-date-picker>
        </v-menu>
        <v-icon class="mr-2 mt-2 text-left" v-if="sort_date" @click="clearDate()">
          mdi-close
        </v-icon>
      </v-row>
      <v-btn text v-tooltip="{
        content: $t('timeline.deposits_tooltip'),
        placement: 'bottom-center',
        delay: {
          show: 500,
          hide: 500,
        },
      }">
        {{ $t('timeline.deposits') }}: {{ deposits }}
      </v-btn>
      <v-btn text v-tooltip="{
        content: $t('timeline.incomes_tooltip'),
        placement: 'bottom-center',
        targetClasses: ['it-has-a-tooltip'],
        delay: {
          show: 500,
          hide: 500,
        },
      }">
        {{ $t('timeline.incomes') }}: {{ incomes }}
      </v-btn>
      <v-btn icon @click="show_checkins = !show_checkins;" v-tooltip="{
        content: $t('timeline.only_checkins'),
        placement: 'bottom-center',
        targetClasses: ['it-has-a-tooltip'],
        delay: {
          show: 500,
          hide: 500,
        },
      }">
        <v-icon :color="show_checkins ? 'warning' : ''">mdi-airplane-takeoff</v-icon>
      </v-btn>
      <v-btn icon @click="show_checkouts = !show_checkouts;" v-tooltip="{
        content: $t('timeline.only_checkouts'),
        placement: 'bottom-center',
        targetClasses: ['it-has-a-tooltip'],
        delay: {
          show: 500,
          hide: 500,
        },
      }">
        <v-icon :color="show_checkouts ? 'warning' : ''">mdi-home</v-icon>
      </v-btn>
      <v-btn icon @click="show_all_bookings = !show_all_bookings;" v-tooltip="{
        content: $t('timeline.all_bookings'),
        placement: 'bottom-center',
        targetClasses: ['it-has-a-tooltip'],
        delay: {
          show: 500,
          hide: 500,
        },
      }">
        <v-icon :color="show_all_bookings ? 'warning' : ''">mdi-all-inclusive-box-outline</v-icon>
      </v-btn>
      <div :class="'pulse mt-3 mx-2 ' + (connected ? 'pulse_success' : 'pulse_error')
        " v-tooltip="{
          content: connected
            ? $t('custom.connected')
            : $t('custom.disconnected'),
          placement: 'bottom-center',
          classes: ['info'],
          targetClasses: ['it-has-a-tooltip'],
          delay: {
            show: 500,
            hide: 500,
          },
        }"></div>
      <v-btn icon :href="docsLink('/kalendar/plan-na-den')" target="_blank">
        <v-icon>mdi-help-circle</v-icon>
      </v-btn>
    </v-toolbar>
    <v-toolbar height="150px" v-if="isMobile" flat
      class="day-plan__toolbar mb-2 start-tour-timeline-1">
      <v-flex md12 class="text-center" justify-center>
        <v-flex md12 class="mt-2 d-flex">
          <v-menu v-model="date_menu_mobile" offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-bind="attrs" v-on="on" readonly :dense="isMobile" v-model="sort_date_for_input"
                :attributes="attrs_calendar" prepend-icon="mdi-calendar-clock" :label="$t('custom.bookings_on_day')"
                single-line hide-details></v-text-field>
            </template>
            <vc-date-picker v-model="sort_date" mode="date" :masks="{ input: 'DD-MM-YYYY' }" :locale="$i18n.locale"
              @input="date_menu_mobile = false">
            </vc-date-picker>
          </v-menu>
          <v-spacer></v-spacer>
          <v-icon class="mr-2 mt-2 text-left" v-if="sort_date" @click="clearDate()">
            mdi-close
          </v-icon>
          <div :class="'pulse mt-3 mx-2 ' + (connected ? 'pulse_success' : 'pulse_error')
            " v-tooltip="{
              content: connected
                ? $t('custom.connected')
                : $t('custom.disconnected'),
              placement: 'bottom-center',
              classes: ['info'],
              targetClasses: ['it-has-a-tooltip'],
              delay: {
                show: 500,
                hide: 500,
              },
            }"></div>
        </v-flex>
        <v-flex md12 class="d-flex text-center justify-center align-center">
          <v-btn icon @click="show_checkins = !show_checkins;" v-tooltip="{
            content: $t('timeline.only_checkins'),
            placement: 'bottom-center',
            targetClasses: ['it-has-a-tooltip'],
            delay: {
              show: 500,
              hide: 500,
            },
          }">
            <v-icon :color="show_checkins ? 'warning' : ''">mdi-airplane-takeoff</v-icon>
          </v-btn>
          <v-btn icon @click="show_checkouts = !show_checkouts;" v-tooltip="{
            content: $t('timeline.only_checkouts'),
            placement: 'bottom-center',
            targetClasses: ['it-has-a-tooltip'],
            delay: {
              show: 500,
              hide: 500,
            },
          }">
            <v-icon :color="show_checkouts ? 'warning' : ''">mdi-home</v-icon>
          </v-btn>
          <v-btn icon @click="show_all_bookings = !show_all_bookings;" v-tooltip="{
            content: $t('timeline.all_bookings'),
            placement: 'bottom-center',
            targetClasses: ['it-has-a-tooltip'],
            delay: {
              show: 500,
              hide: 500,
            },
          }">
            <v-icon :color="show_all_bookings ? 'warning' : ''">mdi-all-inclusive-box-outline</v-icon>
          </v-btn>
        </v-flex>
        <v-flex md12 class="d-flex text-center justify-center align-center">
          <v-btn v-if="show_deposits" @click="show_deposits = !show_deposits;" text v-tooltip="{
            content: $t('timeline.deposits_tooltip'),
            placement: 'bottom-center',
            delay: {
              show: 500,
              hide: 500,
            },
          }">
            {{ $t('timeline.deposits') }}: {{ deposits }}
          </v-btn>
          <v-btn v-else @click="show_deposits = !show_deposits;" text v-tooltip="{
            content: $t('timeline.incomes_tooltip'),
            placement: 'bottom-center',
            targetClasses: ['it-has-a-tooltip'],
            delay: {
              show: 500,
              hide: 500,
            },
          }">
            {{ $t('timeline.incomes') }}: {{ incomes }}
          </v-btn>
        </v-flex>
      </v-flex>
    </v-toolbar>
    <v-timeline :dense="$vuetify.breakpoint.smAndDown" :align-top="$vuetify.breakpoint.xsOnly"
      v-if="bookings && bookings.length > 0">
      <v-timeline-item v-for="booking in (show_all_bookings ? all_bookings : bookings)" :key="booking.id"
        :right="selectBookingState(booking)" :left="!selectBookingState(booking)"
        :color="!selectBookingState(booking) ? 'success' : 'primary'" :icon="!selectBookingState(booking) ? 'mdi-home' : 'mdi-airplane-takeoff'
          ">
        <span slot="opposite" class="day-plan__event" :class="selectBookingState(booking) ? 'day-plan__event--issue' : 'day-plan__event--return'">{{
          !selectBookingState(booking)
            ? $t("custom.checkout")
            : $t("custom.checkin")
        }}</span>
        <v-card flat class="day-plan__card" @dblclick="replaceToBooking(booking)">
          <v-expansion-panels :disabled="isPartner || isGuest"
            @change="$event === 0 && loadCarCondition(booking.car_id)">
            <v-expansion-panel class="day-plan__panel">
              <v-expansion-panel-header class="day-plan__header">
                <span class="day-plan__summary" :class="{ 'day-plan__summary--right': selectBookingState(booking) }">
                  <span class="day-plan__time">{{ returnTime(booking) }}</span>
                  <span class="day-plan__location">{{
                    !selectBookingState(booking)
                      ? booking.location_end
                      : booking.location_start
                  }}</span>
                  <strong class="day-plan__code">{{ booking.car_code }}</strong>
                  <span v-if="booking.technical" class="day-plan__technical">
                    <v-icon size="14">mdi-wrench-outline</v-icon>
                    {{ $t('bookings.tech') }}
                  </span>
                  <rent-to-own-chip :booking="booking" class="ml-1" />
                  <span class="day-plan__actions">
                  <v-menu offset-y v-if="booking.state == 'Новая'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="primary" v-tooltip="{
                          content: $t('bookings.new'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-new-box
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'Подтверждена'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="success" v-tooltip="{
                          content: $t('bookings.approved'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-check-all
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'Не подтверждена'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="warning" v-tooltip="{
                          content: $t('bookings.not_approved'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cellphone-basic
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'В обработке'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="primary" v-tooltip="{
                          content: $t('bookings.in_work'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-autorenew
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'Отказ клиента'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="danger" v-tooltip="{
                          content: $t('bookings.declined'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-account-remove-outline
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'Нет машин'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="secondary" v-tooltip="{
                          content: $t('bookings.declined_free_cars'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-car-off
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'Недозвон'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="warning--text">
                        <v-icon class="mx-1" color="warning" v-tooltip="{
                          content: $t('bookings.not_called'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-phone-off-outline
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'Ожидает ответа клиента'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="pink" v-tooltip="{
                          content: $t('bookings.waiting_for_answer'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-account-question-outline
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'Ожидает оплаты'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="lime" v-tooltip="{
                          content: $t('bookings.waiting_for_pay'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-currency-usd-off
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'Активная'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="light-blue" v-tooltip="{
                          content: $t('bookings.active_state'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-alpha-a-circle-outline
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'Отмена'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="brown" v-tooltip="{
                          content: $t('bookings.canceled_state'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cancel
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'Отъездила'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="light-green" v-tooltip="{
                          content: $t('bookings.ride_true'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-garage-variant
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'Вернуть залог'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="blue" v-tooltip="{
                          content: $t('bookings.waiting_for_deposit'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-keyboard-return
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y v-if="booking.state == 'Другое' || booking.state == null">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon class="mx-1" color="secondary" v-tooltip="{
                          content: $t('bookings.other_state'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-head-question-outline
                        </v-icon>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(state, index) in bookings_states" :key="index"
                        @click="saveBookingState(state.value, booking.id)">
                        <v-list-item-title>
                          {{ state.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-icon v-if="
                    booking.chair ||
                    booking.chair_less_1_year ||
                    booking.booster ||
                    booking.navigator ||
                    booking.mp3 ||
                    booking.charger ||
                    booking.wifi_router ||
                    booking.description ||
                    !booking.technical_check_start ||
                    !booking.technical_check_end
                  " color="warning" class="mx-1" v-tooltip="{
                    content: $t('bookings.need_view'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                    mdi-eye-circle-outline
                  </v-icon>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon v-if="!booking.responsible" color="secondary" class="mx-1" v-tooltip="{
                          content: $t('bookings.responsible'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-account-question
                        </v-icon>
                        <span v-else class="mx-1">
                          <v-icon color="success" class="mr-1" v-tooltip="{
                            content: $t('bookings.responsible'),
                            placement: 'bottom-center',
                            classes: ['info'],
                            targetClasses: ['it-has-a-tooltip'],
                            delay: {
                              show: 500,
                              hide: 500,
                            },
                          }">
                            mdi-account-check
                          </v-icon>
                          {{ booking.responsible }}
                        </span>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-for="(responsible, index) in responsibles" :key="index"
                        @click="updateResponsible(booking.id, responsible.name, responsible.id)">
                        <v-list-item-title>
                          {{ responsible.name ? responsible.name : $t("bookings.no_responsible") }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  </span>
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card-text class="day-plan__details">
                  <div class="day-plan__booking-line">
                    <router-link class="day-plan__booking-reference" :to="{ path: `/bookings/${booking.id}` }">
                      {{ $t('custom.number') }} {{ booking.id }}
                    </router-link>
                    <span class="day-plan__booking-state">{{ translateBookingState(booking.state) }}</span>
                    <div class="day-plan__payment">
                      <v-btn small :color="selectColorPaid(booking)" v-if="
                        (booking.counts && booking.counts.length > 0) ||
                        (booking.in_rent && !booking.technical)
                      " v-tooltip="{
                        content: `${calculatePayments(booking) != $t('bookings.paid')
                          ? $t('bookings.part_paid')
                          : $t('bookings.full_paid')
                          }`,
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">{{ calculatePayments(booking) }}</v-btn>
                      <v-btn small outlined :to="{
                        name: 'BookingCard',
                        params: { id: booking.id },
                      }" color="primary" v-if="
                        !booking.in_rent &&
                        booking.counts &&
                        booking.counts.length === 0 &&
                        !booking.technical
                      " :disabled="!booking.active || booking.in_rent" v-tooltip="{
                          content: $t('bookings.not_paid'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">{{ $t("bookings.not_paid_2") }}</v-btn>
                    </div>
                  </div>
                  <dl class="day-plan__facts">
                    <div class="day-plan__fact">
                      <dt>{{ booking.entity ? $t('custom.company') : $t('custom.client') }}</dt>
                      <dd>
                        <router-link class="day-plan__person" :to="{ path: `/clients/${booking.client_id}` }">
                          <template v-if="booking.entity">{{ booking.entity_name }}</template>
                          <template v-else>{{ booking.last_name }} {{ booking.first_name }} {{ booking.middle_name }}</template>
                        </router-link>
                        <a v-if="booking.client && booking.client.phone" class="day-plan__phone"
                          :href="telHref(booking.client.phone)" :aria-label="$t('custom.phone') + ': ' + formatPhone(booking.client.phone)"
                          @dblclick.stop>
                          <v-icon size="18">mdi-phone-outline</v-icon>
                          {{ formatPhone(booking.client.phone) }}
                        </a>
                      </dd>
                    </div>
                    <div class="day-plan__fact">
                      <dt>{{ $t('custom.object') }}</dt>
                      <dd>
                        <router-link class="day-plan__vehicle" :to="{ path: `/cars/${booking.car_id}` }">
                          {{ booking.car_name }} · {{ booking.car_code }}
                        </router-link>
                        <section v-if="carConditions[booking.car_id]" class="day-plan__condition"
                          @dblclick.stop>
                          <v-progress-linear v-if="carConditions[booking.car_id].loading" indeterminate
                            color="primary" height="2" :aria-label="$t('custom.clean')"></v-progress-linear>
                          <div v-if="carConditions[booking.car_id].error" class="day-plan__condition-error" role="status">
                            {{ $t('errors.car_load') }}
                            <v-btn small text @click="loadCarCondition(booking.car_id)">{{ $t('custom.try_again') }}</v-btn>
                          </div>
                          <div v-if="carConditions[booking.car_id].loaded" class="day-plan__condition-fields">
                            <div v-for="field in carConditionFields" :key="field.name" class="day-plan__condition-field">
                              <span class="day-plan__muted">{{ $t(field.label) }}</span>
                              <v-menu v-if="isStaff" offset-y :disabled="carConditions[booking.car_id].loading || carConditions[booking.car_id].saving">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn small outlined v-bind="attrs" v-on="on"
                                    :loading="carConditions[booking.car_id].saving"
                                    :disabled="carConditions[booking.car_id].loading" data-testid="car-condition-edit">
                                    <v-icon small left :color="carConditionMeta(field, carConditions[booking.car_id][field.name]).color">
                                      {{ carConditionMeta(field, carConditions[booking.car_id][field.name]).icon }}
                                    </v-icon>
                                    {{ $t(carConditionMeta(field, carConditions[booking.car_id][field.name]).key) }}
                                    <v-icon small right>mdi-chevron-down</v-icon>
                                  </v-btn>
                                </template>
                                <v-list dense>
                                  <v-list-item class="day-plan__condition-option" v-for="option in field.options" :key="String(option.value)"
                                    @click="updateCarCondition(booking.car_id, field.name, option.value)">
                                    <v-list-item-icon><v-icon small :color="option.color">{{ option.icon }}</v-icon></v-list-item-icon>
                                    <v-list-item-title>{{ $t(option.key) }}</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                              <span v-else class="day-plan__condition-value">
                                <v-icon small :color="carConditionMeta(field, carConditions[booking.car_id][field.name]).color">
                                  {{ carConditionMeta(field, carConditions[booking.car_id][field.name]).icon }}
                                </v-icon>
                                {{ $t(carConditionMeta(field, carConditions[booking.car_id][field.name]).key) }}
                              </span>
                            </div>
                          </div>
                        </section>
                      </dd>
                    </div>
                  </dl>
                  <dl class="day-plan__period">
                    <div class="day-plan__fact">
                      <dt>{{ $t('custom.checkin') }}</dt>
                      <dd :class="{ 'day-plan__current-date': selectBookingState(booking) }">{{ booking.start_date }}</dd>
                      <dd v-if="booking.location_start" class="day-plan__place">{{ booking.location_start }}</dd>
                    </div>
                    <div class="day-plan__fact">
                      <dt>{{ $t('custom.checkout') }}</dt>
                      <dd :class="{ 'day-plan__current-date': !selectBookingState(booking) }">{{ booking.end_date }}</dd>
                      <dd v-if="booking.location_end" class="day-plan__place">{{ booking.location_end }}</dd>
                    </div>
                  </dl>
                  <div v-if="booking.responsible" class="day-plan__responsible">
                    <v-icon size="18">mdi-account-check-outline</v-icon>
                    <span class="day-plan__muted">{{ $t('board.responsible') }}:</span>
                    <span>{{ booking.responsible }}</span>
                  </div>
                  <div v-if="booking.chair || booking.chair_less_1_year || booking.booster || booking.navigator ||
                    booking.mp3 || booking.charger || booking.wifi_router || booking.other_equipment" class="day-plan__supplement">
                    <div class="day-plan__label">{{ $t('bookings.add_equipment') }}</div>
                    <ul class="day-plan__equipment">
                      <li v-if="booking.chair">{{ $t('bookings.baby_chair') }} — {{ booking.chairs_quantity }}</li>
                      <li v-if="booking.chair_less_1_year">{{ $t('bookings.small_baby_chair') }} — {{ booking.chairs_quantity }}</li>
                      <li v-if="booking.booster">{{ $t('bookings.booster') }} — {{ booking.boosters_quantity }}</li>
                      <li v-if="booking.navigator">{{ $t('bookings.navigator') }}</li>
                      <li v-if="booking.mp3">{{ $t('bookings.mp3') }}</li>
                      <li v-if="booking.charger">{{ $t('bookings.charger') }}</li>
                      <li v-if="booking.wifi_router">{{ $t('bookings.wifi') }}</li>
                      <li v-if="booking.other_equipment">{{ booking.other_equipment }}</li>
                    </ul>
                  </div>
                  <div v-if="booking.description || booking.technical_check_start_comment || booking.technical_check_end_comment"
                    class="day-plan__notes">
                    <div v-if="booking.description">
                      <div class="day-plan__label">{{ $t('custom.description_2') }}</div>
                      <p>{{ booking.description }}</p>
                    </div>
                    <div v-if="booking.technical_check_start_comment">
                      <div class="day-plan__label">{{ $t('custom.checkin') }}</div>
                      <p>{{ booking.technical_check_start_comment }}</p>
                    </div>
                    <div v-if="booking.technical_check_end_comment">
                      <div class="day-plan__label">{{ $t('custom.checkout') }}</div>
                      <p>{{ booking.technical_check_end_comment }}</p>
                    </div>
                  </div>
                </v-card-text>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-timeline-item>
    </v-timeline>
    <v-card v-else flat class="day-plan__card mt-3">
      <v-card-title>
        <h3>
          {{ $t("custom.on") }} {{ sort_date_for_input }}
          {{ $t("custom.no_business") }}
        </h3>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import { findBookingIn, refuseRidedState } from "@/utils/ridedStateGuard";
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { Capacitor } from "@capacitor/core";
import CableSubscriber from "@/mixins/CableSubscriber";
import { getConsumer } from "@/cable";
// Итоги дня (залог и приход по броне) — чистые функции, покрыты
// tests/unit/calendars/timelineTotals.spec.js.
import { bookingDeposit, bookingIncome } from "@/components/dashboard/calendars/timelineTotals";
import { depositFieldFor } from "@/components/dashboard/bookings/addonsMath";
import RentToOwnChip from "@/components/dashboard/bookings/RentToOwnChip.vue";
import { formatPhone, telHref } from "@/lib/phone/display";
import { cleanMeta, tankMeta } from "@/components/dashboard/bookings/carConditionMeta";
import { rentalObjectHas, companyRentalObject } from "@/utils/rentalObjectFeatures";
export default {
  mixins: [CableSubscriber],
  data() {
    return {
      subscribedCompanyId: null, // ID компании для отписки от канала
      bookings: [],
      all_bookings: [],
      non_filtered_bookings: [],
      non_filtered_all_bookings: [],
      responsibles: [],
      carConditions: {},
      bookings_states: [
        { text: this.$t("bookings_states.new"), value: "Новая" },
        { text: this.$t("bookings_states.in_work"), value: "В обработке" },
        { text: this.$t("bookings_states.abandoned"), value: "Недозвон" },
        { text: this.$t("bookings_states.decline"), value: "Отказ клиента" },
        { text: this.$t("bookings_states.no_cars"), value: "Нет машин" },
        {
          text: this.$t("bookings_states.wait_answer"),
          value: "Ожидает ответа клиента",
        },
        { text: this.$t("bookings_states.wait_pay"), value: "Ожидает оплаты" },
        { text: this.$t("bookings_states.active"), value: "Активная" },
        { text: this.$t("bookings_states.cancel"), value: "Отмена" },
        { text: this.$t("bookings_states.rided"), value: "Отъездила" },
        {
          text: this.$t("bookings_states.return_deposit"),
          value: "Вернуть залог",
        },
        { text: this.$t("bookings_states.accepted"), value: "Подтверждена" },
        {
          text: this.$t("bookings_states.not_accepted"),
          value: "Не подтверждена",
        },
        { text: this.$t("bookings_states.other"), value: "Другое" },
      ],
      sort_date: new Date(),
      sort_date_for_input: null,
      // Меню пикеров даты: close-on-content-click по дефолту закрывал меню
      // кликом по стрелке месяца — закрываем сами при выборе даты.
      date_menu: false,
      date_menu_mobile: false,
      attrs_calendar: [
        {
          key: "today",
          highlight: {
            color: "blue",
            fillMode: "outline",
            contentClass: "italic",
          },
          dates: new Date(),
        },
      ],
      show_all_bookings: false,
      show_checkins: false,
      show_checkouts: false,
      show_deposits: true,
      connected: false,
      isMobile: false,
      isLoading: false,
      isLoadingSubscribeToPaidTariff: false,
    };
  },
  mounted() {
    // Паритет с остальными cable-подписками: было «не partner и не guest»,
    // то есть staff + agent. Календарь агенту из меню недоступен, но условие
    // держим единым для всех подписок — иначе следующая правка снова разъедется.
    if ((this.isStaff || this.isAgent) && this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.id) {
      this.subscribedCompanyId = this.$store.getters.getCompany.company.id;
      // FT-066: native held-ref sub; handlers via arrows (this-rebinding). Mixin auto-unsubscribes.
      this.timelineSub = this.$cableSubscribe(
        { channel: "TimelineChannel", room: this.subscribedCompanyId },
        {
          connected: () => this.onTimelineConnected(),
          disconnected: () => this.onTimelineDisconnected(),
          received: (data) => this.onTimelineReceived(data),
        }
      );
    }
    if (
      this.$tours["registrationTour"] &&
      this.$store.getters.getTourNextStep
    ) {
      this.$tours["registrationTour"].nextStep();
    }
    let self = this;
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      this.isLoading = true;
      this.sort_date_for_input = moment(this.sort_date).format("DD-MM-YYYY");
      this.axios
        .get(`/api/v1/bookings_for_date?date=${self.sort_date_for_input}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          self.bookings = response.data;
          self.all_bookings = response.data;
          self.non_filtered_bookings = response.data;
          self.non_filtered_all_bookings = response.data;
          // Добавляю время для сортировки
          self.bookings.forEach((booking) => {
            if (!self.selectBookingState(booking)) {
              booking.time = moment(booking.end_date, "DD-MM-YYYY H:mm").format(
                "H:mm"
              );
            } else {
              booking.time = moment(
                booking.start_date,
                "DD-MM-YYYY H:mm"
              ).format("H:mm");
            }
          });
          // Добавляю время для сортировки
          self.all_bookings.forEach((booking) => {
            if (!self.selectBookingState(booking)) {
              booking.time = moment(booking.end_date, "DD-MM-YYYY H:mm").format(
                "H:mm"
              );
            } else {
              booking.time = moment(
                booking.start_date,
                "DD-MM-YYYY H:mm"
              ).format("H:mm");
            }
          });
          // Добавляю время для сортировки
          self.non_filtered_bookings.forEach((booking) => {
            if (!self.selectBookingState(booking)) {
              booking.time = moment(booking.end_date, "DD-MM-YYYY H:mm").format(
                "H:mm"
              );
            } else {
              booking.time = moment(
                booking.start_date,
                "DD-MM-YYYY H:mm"
              ).format("H:mm");
            }
          });
          // Добавляю время для сортировки
          self.non_filtered_all_bookings.forEach((booking) => {
            if (!self.selectBookingState(booking)) {
              booking.time = moment(booking.end_date, "DD-MM-YYYY H:mm").format(
                "H:mm"
              );
            } else {
              booking.time = moment(
                booking.start_date,
                "DD-MM-YYYY H:mm"
              ).format("H:mm");
            }
          });
          // Сортирую по времени
          self.bookings = self.bookings.sort(function (x1, x2) {
            if (moment(x1.time, "H:mm").isBefore(moment(x2.time, "H:mm")))
              return -1;
            if (moment(x1.time, "H:mm").isAfter(moment(x2.time, "H:mm")))
              return 1;
            return 0;
          });
          // Сортирую по времени
          self.all_bookings = self.all_bookings.sort(function (x1, x2) {
            if (moment(x1.time, "H:mm").isBefore(moment(x2.time, "H:mm")))
              return -1;
            if (moment(x1.time, "H:mm").isAfter(moment(x2.time, "H:mm")))
              return 1;
            return 0;
          });
          // Сортирую по времени
          self.non_filtered_bookings = self.non_filtered_bookings.sort(function (
            x1,
            x2
          ) {
            if (moment(x1.time, "H:mm").isBefore(moment(x2.time, "H:mm")))
              return -1;
            if (moment(x1.time, "H:mm").isAfter(moment(x2.time, "H:mm")))
              return 1;
            return 0;
          });
          // Сортирую по времени
          self.non_filtered_all_bookings = self.non_filtered_all_bookings.sort(function (
            x1,
            x2
          ) {
            if (moment(x1.time, "H:mm").isBefore(moment(x2.time, "H:mm")))
              return -1;
            if (moment(x1.time, "H:mm").isAfter(moment(x2.time, "H:mm")))
              return 1;
            return 0;
          });
          // Убираю те которые уже выдали
          self.bookings = self.bookings.filter((booking) => {
            return !(
              booking.in_rent &&
              moment(booking.end_date, "DD-MM-YYYY H:mm").isAfter(
                moment(),
                "days"
              )
            );
          });
          // Убираю те которые уже выдали
          self.non_filtered_bookings = self.non_filtered_bookings.filter((booking) => {
            return !(
              booking.in_rent &&
              moment(booking.end_date, "DD-MM-YYYY H:mm").isAfter(
                moment(),
                "days"
              )
            );
          });
        })
        .then(() => {
          this.axios
            .get("/api/v1/get_workers_names_with_ids", {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then((response) => {
              this.responsibles = response.data;
              // добавляем в массив отсутствие ответственного
              this.responsibles.push({
                id: null,
                name: null,
              });
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.workers_load"));
              console.log(error);
            });
        })
        .catch((error) => {
          self.setError(error, self.$t("errors.bookings_load"));
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });

      // FT-066: health-check via native consumer (replaced the old wrapper-registry probe).
      // getConsumer().connection.isOpen() is the public @rails/actioncable API. Dead commented
      // reconnect dropped — native consumer auto-reopens on drop.
      // check every 30 seconds if action cable wss server is online
      function check_server() {
        self.check_server = setInterval(function () {
          const consumer = getConsumer();
          self.connected = !!(consumer && consumer.connection && consumer.connection.isOpen());
        }.bind(self), 30000);
      }
      check_server();
    } else {
      this.$store.commit("unsetCurrentUser");
      // this.$router.push({ path: `/signin` }).catch(err => {});
    }
  },
  beforeDestroy() {
    // FT-066: CableSubscriber mixin auto-unsubscribes the held TimelineChannel ref.
    this.$cableUnsubscribe(this.timelineSub);
    this.timelineSub = null;
  },
  destroyed() {
    clearInterval(this.check_server);
  },
  watch: {
    sort_date() {
      let self = this;
      if (this.sort_date) {
        this.getBookingsForDate();
        this.sort_date_for_input = moment(this.sort_date).format("DD-MM-YYYY");
      } else {
        this.sort_date = new Date().toISOString();
        this.sort_date_for_input = moment().format("DD-MM-YYYY");
      }
    },
    show_checkins() {
      if (this.show_checkins) {
        // this.show_all_bookings = false;
        this.bookings = this.bookings.filter((booking) => {
          return this.selectBookingState(booking);
        });
        this.all_bookings = this.all_bookings.filter((booking) => {
          return this.selectBookingState(booking);
        });
      } else {
        this.bookings = this.non_filtered_bookings;
        this.all_bookings = this.non_filtered_all_bookings;
      }
      this.show_checkouts = false;
    },
    show_checkouts() {
      if (this.show_checkouts) {
        this.bookings = this.bookings.filter((booking) => {
          return !this.selectBookingState(booking);
        });
        this.all_bookings = this.all_bookings.filter((booking) => {
          return !this.selectBookingState(booking);
        });
      } else {
        this.bookings = this.non_filtered_bookings;
        this.all_bookings = this.non_filtered_all_bookings;
      }
      this.show_checkins = false;
    },
  },
  computed: {
    showFuel() {
      return rentalObjectHas(companyRentalObject(this.$store.getters.getCompany) || 'cars', 'fuel');
    },
    carConditionFields() {
      const fields = [{
        name: 'clean_state',
        label: 'custom.clean',
        options: [true, false].map(value => ({ value, ...cleanMeta(value) })),
      }];
      if (this.showFuel) {
        fields.push({
          name: 'tank_state',
          label: 'custom.tank',
          options: [true, false].map(value => ({ value, ...tankMeta(value) })),
        });
      }
      return fields;
    },
    userMustChangeTariffPlan() {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan && this.$store.getters.getMainCompany.plan.id) {
          if(this.$store.getters.getMainCompany.plan.name == "Старт" || this.$store.getters.getMainCompany.plan.name == "Start") {
            if(this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment())) {
              return false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else {
          return false
        }
      } else {
        return false;
      }
    },
    deposits() {
      // считаю залоги на сегодня
      let deposits = 0;
      this.bookings.forEach((booking) => {
        // Ветвление было двухходовым (hourly / всё остальное), из-за чего
        // недельные и месячные брони считались по пустому booking.deposit —
        // их залог лежит в weekly_deposit / monthly_deposit.
        const deposit = bookingDeposit(booking);
        if (deposit && deposit > 0 && (moment(booking.end_date, "DD-MM-YYYY H:mm").isSame(moment(this.sort_date), "days")) && !booking.technical) {
          deposits += deposit;
        }
      });
      return deposits;
    },
    incomes() {
      // считаю приход на сегодня
      let incomes = 0;
      this.bookings.forEach((booking) => {
        if ((moment(booking.start_date, "DD-MM-YYYY H:mm").isSame(moment(this.sort_date), "days")) && !booking.technical) {
          const booking_sum = bookingIncome(booking);
          if (booking_sum > 0) {
            incomes += booking_sum;
          }
        }
      });
      return incomes;
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
  },
  methods: {
    carConditionMeta(field, value) {
      return field.options.find(option => option.value === value) || {
        icon: 'mdi-help-circle-outline', color: 'grey', key: 'custom.unknown',
      };
    },
    async loadCarCondition(carId) {
      if (!carId) return;
      if (!this.carConditions[carId]) {
        this.$set(this.carConditions, carId, {
          loaded: false, loading: false, saving: false, error: false,
          clean_state: null, tank_state: null,
        });
      }
      const condition = this.carConditions[carId];
      if (condition.loading || condition.saving) return;
      condition.loading = true;
      condition.error = false;
      try {
        const { data } = await this.axios.get(`/api/v1/cars/${carId}`, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        });
        condition.clean_state = typeof data.clean_state === 'boolean' ? data.clean_state : null;
        condition.tank_state = typeof data.tank_state === 'boolean' ? data.tank_state : null;
        condition.loaded = true;
      } catch (error) {
        condition.loaded = false;
        condition.error = true;
        this.setError(error, this.$t('errors.car_load'));
      } finally {
        condition.loading = false;
      }
    },
    async updateCarCondition(carId, field, value) {
      if (!this.isStaff) {
        this.$notify(this.$t('errors.no_access'), '', 'warning');
        return;
      }
      if (!['clean_state', 'tank_state'].includes(field) || typeof value !== 'boolean') return;
      if (field === 'tank_state' && !this.showFuel) return;
      const condition = this.carConditions[carId];
      if (!condition || !condition.loaded || condition.loading || condition.saving || condition[field] === value) return;
      condition.saving = true;
      try {
        await this.axios.patch(`/api/v1/cars/${carId}`, { cars: { [field]: value } }, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        });
        condition[field] = value;
      } catch (error) {
        this.setError(error, this.$t('errors.car_state_update'));
      } finally {
        condition.saving = false;
      }
    },
    formatPhone,
    telHref,
    // FT-066: TimelineChannel handlers (moved 1:1 from the old declarative channel).
    onTimelineConnected() {
      console.log("connected");
      this.connected = "success";
    },
    onTimelineDisconnected() {
      console.log("disconnected");
      this.connected = "error";
    },
    onTimelineReceived(data) {
      // вставляем свежие платежи
      data.booking.counts = data.counts;
      if (data.action == "new") {
        if (
          data.booking &&
          (moment(data.booking.start_date, "DD-MM-YYYY H:mm").isSame(
            moment(this.sort_date_for_input, "DD-MM-YYYY"),
            "day"
          ) ||
            moment(data.booking.end_date, "DD-MM-YYYY H:mm").isSame(
              moment(this.sort_date_for_input, "DD-MM-YYYY"),
              "day"
            ))
        ) {
          console.log(
            "received and push",
            data,
            moment(data.booking.start_date, "DD-MM-YYYY H:mm").isSame(
              moment(this.sort_date_for_input, "DD-MM-YYYY"),
              "day"
            ),
            moment(data.booking.end_date, "DD-MM-YYYY H:mm").isSame(
              moment(this.sort_date_for_input, "DD-MM-YYYY"),
              "day"
            )
          );

          this.bookings.push(data.booking);
          // Добавляю время для сортировки
          this.bookings.forEach((booking) => {
            if (!this.selectBookingState(booking)) {
              booking.time = moment(
                booking.end_date,
                "DD-MM-YYYY H:mm"
              ).format("H:mm");
            } else {
              booking.time = moment(
                booking.start_date,
                "DD-MM-YYYY H:mm"
              ).format("H:mm");
            }
          });
          // Сортирую по времени
          this.bookings = this.bookings.sort(function (x1, x2) {
            if (moment(x1.time, "H:mm").isBefore(moment(x2.time, "H:mm")))
              return -1;
            if (moment(x1.time, "H:mm").isAfter(moment(x2.time, "H:mm")))
              return 1;
            return 0;
          });
          // Убираю те которые уже выдали
          this.bookings = this.bookings.filter((booking) => {
            return !(
              booking.in_rent &&
              moment(booking.end_date, "DD-MM-YYYY H:mm").isAfter(
                moment(),
                "days"
              )
            );
          });
        }
      }
      if (data.action == "update") {
        if (
          data.booking.archive == true ||
          data.booking.ride == true ||
          data.booking.active == false
        ) {
          this.bookings = this.bookings.filter((booking) => {
            return booking.id != data.booking.id;
          });
        } else {
          let index = this.bookings.findIndex(
            (booking) => booking.id == data.booking.id
          );
          // вставляем свежие платежи
          data.booking.counts = data.counts;
          if (index != -1) {
            this.bookings.splice(index, 1, data.booking);
          } else {
            this.bookings.push(data.booking);
          }
        }
        // Убираю не на этот день
        this.bookings = this.bookings.filter((booking) => {
          return (
            moment(booking.start_date, "DD-MM-YYYY H:mm").isSame(
              moment(this.sort_date_for_input, "DD-MM-YYYY"),
              "day"
            ) ||
            moment(booking.end_date, "DD-MM-YYYY H:mm").isSame(
              moment(this.sort_date_for_input, "DD-MM-YYYY"),
              "day"
            )
          );
        });

        // Добавляю время для сортировки
        this.bookings.forEach((booking) => {
          if (!this.selectBookingState(booking)) {
            booking.time = moment(booking.end_date, "DD-MM-YYYY H:mm").format(
              "H:mm"
            );
          } else {
            booking.time = moment(
              booking.start_date,
              "DD-MM-YYYY H:mm"
            ).format("H:mm");
          }
        });
        // Сортирую по времени
        this.bookings = this.bookings.sort(function (x1, x2) {
          if (moment(x1.time, "H:mm").isBefore(moment(x2.time, "H:mm")))
            return -1;
          if (moment(x1.time, "H:mm").isAfter(moment(x2.time, "H:mm")))
            return 1;
          return 0;
        });
        // // Убираю те которые уже выдали
        // this.bookings = this.bookings.filter((booking) => {
        //   return !(
        //     booking.in_rent &&
        //     moment(booking.end_date, "DD-MM-YYYY H:mm").isAfter(
        //       moment(),
        //       "days"
        //     )
        //   );
        // });
      }
      if (data.action == "destroy") {
        console.log("destroy");
        this.bookings.splice(
          this.bookings.findIndex((booking) => booking.id == data.booking),
          1
        );
      }
    },
    getBookingsForDate() {
      let self = this;
      if (this.sort_date) {
        this.isLoading = true;
        this.show_checkins = false;
        this.show_checkouts = false;
        this.show_all_bookings = false;
        let formattedDate = moment(self.sort_date).format("DD-MM-YYYY");
        this.axios
          .get(`/api/v1/bookings_for_date?date=${formattedDate}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            self.bookings = response.data;
            self.all_bookings = response.data;
            self.non_filtered_bookings = response.data;
            self.non_filtered_all_bookings = response.data;
            // Добавляю время для сортировки
            self.bookings.forEach((booking) => {
              if (!self.selectBookingState(booking)) {
                booking.time = moment(
                  booking.end_date,
                  "DD-MM-YYYY H:mm"
                ).format("H:mm");
              } else {
                booking.time = moment(
                  booking.start_date,
                  "DD-MM-YYYY H:mm"
                ).format("H:mm");
              }
            });
            self.all_bookings.forEach((booking) => {
              if (!self.selectBookingState(booking)) {
                booking.time = moment(
                  booking.end_date,
                  "DD-MM-YYYY H:mm"
                ).format("H:mm");
              } else {
                booking.time = moment(
                  booking.start_date,
                  "DD-MM-YYYY H:mm"
                ).format("H:mm");
              }
            });
            self.non_filtered_bookings.forEach((booking) => {
              if (!self.selectBookingState(booking)) {
                booking.time = moment(
                  booking.end_date,
                  "DD-MM-YYYY H:mm"
                ).format("H:mm");
              } else {
                booking.time = moment(
                  booking.start_date,
                  "DD-MM-YYYY H:mm"
                ).format("H:mm");
              }
            });
            self.non_filtered_all_bookings.forEach((booking) => {
              if (!self.selectBookingState(booking)) {
                booking.time = moment(
                  booking.end_date,
                  "DD-MM-YYYY H:mm"
                ).format("H:mm");
              } else {
                booking.time = moment(
                  booking.start_date,
                  "DD-MM-YYYY H:mm"
                ).format("H:mm");
              }
            });
            // Сортирую по времени
            self.bookings = self.bookings.sort(function (x1, x2) {
              if (moment(x1.time, "H:mm").isBefore(moment(x2.time, "H:mm")))
                return -1;
              if (moment(x1.time, "H:mm").isAfter(moment(x2.time, "H:mm")))
                return 1;
              return 0;
            });
            // Сортирую по времени
            self.all_bookings = self.all_bookings.sort(function (x1, x2) {
              if (moment(x1.time, "H:mm").isBefore(moment(x2.time, "H:mm")))
                return -1;
              if (moment(x1.time, "H:mm").isAfter(moment(x2.time, "H:mm")))
                return 1;
              return 0;
            });
            // Сортирую по времени
            self.non_filtered_bookings = self.non_filtered_bookings.sort(function (x1, x2) {
              if (moment(x1.time, "H:mm").isBefore(moment(x2.time, "H:mm")))
                return -1;
              if (moment(x1.time, "H:mm").isAfter(moment(x2.time, "H:mm")))
                return 1;
              return 0;
            });
            // Сортирую по времени
            self.non_filtered_all_bookings = self.bookings.sort(function (x1, x2) {
              if (moment(x1.time, "H:mm").isBefore(moment(x2.time, "H:mm")))
                return -1;
              if (moment(x1.time, "H:mm").isAfter(moment(x2.time, "H:mm")))
                return 1;
              return 0;
            });
            if (moment().isSame(this.sort_date, "days")) {
              // Убираю те которые уже выдали
              self.bookings = self.bookings.filter((booking) => {
                return !(
                  booking.in_rent &&
                  moment(booking.end_date, "DD-MM-YYYY H:mm").isAfter(
                    moment(),
                    "days"
                  )
                );
              });
            }
            if (moment().isSame(this.sort_date, "days")) {
              // Убираю те которые уже выдали
              self.non_filtered_bookings = self.non_filtered_bookings.filter((booking) => {
                return !(
                  booking.in_rent &&
                  moment(booking.end_date, "DD-MM-YYYY H:mm").isAfter(
                    moment(),
                    "days"
                  )
                );
              });
            }
          })
          .catch((error) => {
            self.setError(error, self.$t("errors.bookings_load"));
            console.log(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$notify(this.$t("errors.error"), this.$t("errors.bad_date"), "warning");
      }
    },
    selectBookingState(booking) {
      if (
        moment(booking.start_date, "DD-MM-YYYY H:mm").isSame(
          moment(booking.end_date, "DD-MM-YYYY H:mm"),
          "days"
        ) &&
        booking.in_rent == true
      ) {
        // Бронь однодневка, чтобы не показывать когда выдана в выдаче, а показывать в приеме
        return false;
      } else if (
        // выдача
        moment(booking.start_date, "DD-MM-YYYY H:mm").isSame(
          moment(this.sort_date),
          "days"
        ) &&
        booking.ride == false
      ) {
        return true;
      } else {
        // прием
        return false;
      }
    },
    returnTime(booking) {
      if (!this.selectBookingState(booking)) {
        return moment(booking.end_date, "DD-MM-YYYY H:mm").format("H:mm");
      } else if (this.selectBookingState(booking)) {
        return moment(booking.start_date, "DD-MM-YYYY H:mm").format("H:mm");
      } else {
        return `${booking.start_date} - ${booking.end_date}`;
      }
    },
    calculatePayments(booking) {
      if (booking != undefined && booking.counts && booking.counts.length > 0) {
        let paid = 0;
        // Проверяем что значения числовые
        let check_number_rental_cost = Number(booking.rental_cost) === booking.rental_cost;
        let check_number_delivery = Number(booking.delivery) === booking.delivery;
        let check_number_delivery_end = Number(booking.delivery_end) === booking.delivery_end;
        let check_number_equipment = Number(booking.equipment) === booking.equipment;
        let check_number_insurance = Number(booking.insurance) === booking.insurance;
        let check_number_clean_payment = Number(booking.clean_payment) === booking.clean_payment;
        let check_number_add_drivers_cost = Number(booking.add_drivers_cost) === booking.add_drivers_cost;
        let check_number_hours_cost = Number(booking.hours_cost) === booking.hours_cost;
        let check_number_hours_cost_end = Number(booking.hours_cost_end) === booking.hours_cost_end;
        let check_number_mileage_cost = Number(booking.mileage_cost) === booking.mileage_cost;
        let check_number_damage = Number(booking.damage) === booking.damage;
        let check_number_gas = Number(booking.gas) === booking.gas;
        let check_number_fine = Number(booking.fine) === booking.fine;
        let check_number_other = Number(booking.other) === booking.other;
        let check_number_other_end = Number(booking.other_end) === booking.other_end;
        // FT-102 REQ-07: каталожное оборудование — компонент суммы «к оплате»
        let check_number_addons_cost = Number(booking.addons_cost) === booking.addons_cost;
        let rental_cost = check_number_rental_cost ? booking.rental_cost : 0;
        let delivery = check_number_delivery ? booking.delivery : 0;
        let delivery_end = check_number_delivery_end ? booking.delivery_end : 0;
        let equipment = check_number_equipment ? booking.equipment : 0;
        let insurance = check_number_insurance ? booking.insurance : 0;
        let clean_payment = check_number_clean_payment ? booking.clean_payment : 0;
        let add_drivers_cost = check_number_add_drivers_cost ? booking.add_drivers_cost : 0;
        let hours_cost = check_number_hours_cost ? booking.hours_cost : 0;
        let mileage_cost = check_number_mileage_cost ? booking.mileage_cost : 0;
        let damage = check_number_damage ? booking.damage : 0;
        let gas = check_number_gas ? booking.gas : 0;
        let fine = check_number_fine ? booking.fine : 0;
        let other = check_number_other ? booking.other : 0;
        let other_end = check_number_other_end ? booking.other_end : 0;
        let hours_cost_end = check_number_hours_cost_end ? booking.hours_cost_end : 0;
        let addons_cost = check_number_addons_cost ? booking.addons_cost : 0;
        let booking_sum =
          parseFloat((rental_cost +
            delivery +
            delivery_end +
            equipment +
            addons_cost +
            insurance +
            clean_payment +
            add_drivers_cost +
            hours_cost +
            mileage_cost +
            damage +
            gas +
            fine +
            other +
            other_end +
            hours_cost_end).toFixed(2));
        booking.counts.forEach((count) => {
          // если оплата по терминалу и в платеже есть tinkoff_payment_id то учитываем только если count.tinkoff_payment.paid = true
          if (count.completed) {
            if (count.operation) {
              if(this.company && this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                let ratedSum = Number(count.rated_sum);
                paid += ratedSum;
              } else {
                let sum = Number(count.sum);
                paid += sum;
              }
            } else {
              if(this.company && this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                let ratedSum = Number(count.rated_sum);
                paid -= ratedSum;
              } else {
                let sum = Number(count.sum);
                paid -= sum;
              }
            }
          }
        });
        // Округляем сумму до 2 знаков после запятой
        booking_sum = parseFloat(booking_sum.toFixed(2));
        paid = parseFloat(paid.toFixed(2));
        // Отнимаем залог у непринятых броней
        if (!booking.ride) {
          booking_sum += booking[depositFieldFor(booking)] || 0;
        }
        if (parseInt(paid) == parseInt(booking_sum)) {
          return this.$t("bookings.paid");
        } else {
          return paid - booking_sum >= 0
            ? `+ ${paid - booking_sum}`
            : ` ${paid - booking_sum}`;
        }
      } else {
        return this.$t("bookings.not_paid_2");
      }
    },
    selectColorPaid(booking) {
      if (booking != undefined && booking.counts && booking.counts.length > 0) {
        let paid = 0;
        let booking_sum =
          booking.rental_cost +
          booking.delivery +
          booking.delivery_end +
          booking.equipment +
          (booking.addons_cost || 0) + // FT-102 REQ-07

          booking.insurance +
          booking.clean_payment +
          booking.add_drivers_cost +
          booking.hours_cost +
          booking.mileage_cost +
          booking.damage +
          booking.gas +
          booking.fine +
          booking.other +
          booking.other_end +
          booking.hours_cost_end;
        booking.counts.forEach((count) => {
          // если оплата по терминалу и в платеже есть tinkoff_payment_id то учитываем только если count.tinkoff_payment.paid = true
          if (count.completed) {
            if (count.operation) {
              if(this.company && this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                let ratedSum = Number(count.rated_sum);
                paid += ratedSum;
              } else {
                let sum = Number(count.sum);
                paid += sum;
              }
            } else {
              if(this.company && this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                let ratedSum = Number(count.rated_sum);
                paid -= ratedSum;
              } else {
                let sum = Number(count.sum);
                paid -= sum;
              }
            }
          }
        });
        // Округляем сумму до 2 знаков после запятой
        booking_sum = parseFloat(booking_sum.toFixed(2));
        paid = parseFloat(paid.toFixed(2));
        // Отнимаем залог у непринятых броней
        if (!booking.ride) {
          booking_sum += booking[depositFieldFor(booking)] || 0;
        }
        if (parseInt(paid) == parseInt(booking_sum)) {
          return "success";
        } else if (paid - booking_sum > 0) {
          return "warning";
        } else if (paid - booking_sum < 0) {
          return "error";
        }
      } else {
        return "error";
      }
    },
    updateResponsible(id, responsible_name, responsible_id) {
      if (this.isStaff) {
        this.isLoading = true;
        let self = this;
        this.axios
          .patch(
            `/api/v1/update_responsible`,
            {
              bookings: {
                id: id,
                responsible: responsible_name,
                responsible_id: responsible_id
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            let foundIndex = this.bookings.findIndex(
              (element) => element.id === id
            );
            this.bookings.splice(foundIndex, 1, response.data);

            this.$notify(this.$t("bookings.responsible_changed_title"), this.$t("bookings.responsible_changed_text"), "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.change_responsible"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveBookingState(state, id) {
      if (this.isStaff) {
        let self = this;
        if ((state, id)) {
          if (refuseRidedState(this, findBookingIn(id, this.bookings, this.all_bookings), state)) return;
          this.isLoading = true;
          this.axios
            .patch(
              `/api/v1/bookings/${id}`,
              {
                bookings: {
                  state: state,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              let foundIndex = this.bookings.findIndex(
                (element) => element.id === id
              );
              console.log(this.bookings[foundIndex])
              this.bookings[foundIndex].state = state;
              console.log(this.bookings[foundIndex])
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.update_state_title"));
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.select_state"), this.error, "warning");
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    translateBookingState(state) {
      switch (state) {
        case "Новая":
          return this.$t("bookings_states.new");
        case "В обработке":
          return this.$t("bookings_states.in_work");
        case "Недозвон":
          return this.$t("bookings_states.abandoned");
        case "Отказ клиента":
          return this.$t("bookings_states.decline");
        case "Нет машин":
          return this.$t("bookings_states.no_cars");
        case "Ожидает ответа клиента":
          return this.$t("bookings_states.wait_answer");
        case "Активная":
          return this.$t("bookings_states.active");
        case "Отмена":
          return this.$t("bookings_states.cancel");
        case "Отъездила":
          return this.$t("bookings_states.rided");
        case "Вернуть залог":
          return this.$t("bookings_states.return_deposit");
        case "Подтверждена":
          return this.$t("bookings_states.accepted");
        case "Не подтверждена":
          return this.$t("bookings_states.not_accepted");
        case "Другое":
          return this.$t("bookings_states.other");
        default:
          return this.$t("bookings_states.in_work");
      }
    },
    clearDate() {
      this.sort_date = new Date();
      this.sort_date_for_input = moment().format("DD-MM-YYYY");
    },
    replaceToBooking(booking) {
      this.$router.push({ path: `/bookings/${booking.id}` });
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        var fpath = this.PageData.backCrumb.url;
        this.$router
          .push({
            path: fpath,
          })
          .catch((err) => { });
      }
    },
  },
  components: {
    RentToOwnChip,
  },
};
</script>

<style scoped>
.day-plan {
  --day-plan-canvas: #f5f6f8;
  --day-plan-surface: #ffffff;
  --day-plan-edge: #d9dfe7;
  --day-plan-ink: #20252b;
  --day-plan-muted: #59636f;
  --day-plan-link: #1565c0;
  --day-plan-return: #2e7d32;
  --day-plan-badge: #edf0f4;

  min-height: 100%;
  padding: 8px;
  background: var(--day-plan-canvas);
  color: var(--day-plan-ink);
}

.day-plan--dark {
  --day-plan-canvas: #181a1e;
  --day-plan-surface: #24272c;
  --day-plan-edge: #3b414b;
  --day-plan-ink: #e7eaf0;
  --day-plan-muted: #adb5c0;
  --day-plan-link: #82b1ff;
  --day-plan-return: #81c784;
  --day-plan-badge: #343a43;
}

.day-plan .day-plan__toolbar,
.day-plan .day-plan__card,
.day-plan .day-plan__panel {
  background-color: var(--day-plan-surface);
  color: var(--day-plan-ink);
}

.day-plan .day-plan__toolbar {
  border-bottom: 1px solid var(--day-plan-edge);
}

.day-plan .day-plan__card {
  overflow: hidden;
  border: 1px solid var(--day-plan-edge);
  border-radius: 12px;
}

.day-plan__panel::before {
  box-shadow: none;
}

.day-plan__header {
  padding: 16px 20px;
}

.day-plan__summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding-right: 12px;
}

.day-plan__summary--right {
  justify-content: flex-end;
}

.day-plan__time,
.day-plan__code {
  font-weight: 600;
}

.day-plan__time {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.day-plan__location,
.day-plan__code {
  overflow-wrap: anywhere;
}

.day-plan__location,
.day-plan__muted {
  color: var(--day-plan-muted);
}

.day-plan__technical {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  padding: 4px 8px;
  border-radius: 4px;
  background: var(--day-plan-badge);
  color: var(--day-plan-muted);
  font-size: 12px;
  line-height: 16px;
  overflow-wrap: anywhere;
}

.day-plan__technical .v-icon {
  color: inherit;
}

.day-plan__actions {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 100%;
  overflow-wrap: anywhere;
}

.day-plan .day-plan__details {
  padding: 0;
  color: var(--day-plan-ink);
  overflow-wrap: anywhere;
}

.day-plan__booking-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  padding: 16px 0;
  border-top: 1px solid var(--day-plan-edge);
}

.day-plan__booking-reference {
  font-size: 16px;
  font-weight: 600;
}

.day-plan__booking-state {
  padding: 4px 8px;
  border-radius: 4px;
  background: var(--day-plan-badge);
  color: var(--day-plan-muted);
  line-height: 18px;
}

.day-plan__payment {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
}

.day-plan__facts,
.day-plan__period {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 220px), 1fr));
  gap: 20px 24px;
  margin: 0;
}

.day-plan__fact {
  min-width: 0;
}

.day-plan__fact dt,
.day-plan__label {
  margin-bottom: 6px;
  color: var(--day-plan-muted);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
}

.day-plan__fact dd {
  margin: 0;
  line-height: 1.5;
}

.day-plan__person,
.day-plan__vehicle {
  font-size: 15px;
  font-weight: 500;
}

.day-plan__phone {
  display: flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  max-width: 100%;
  min-height: 36px;
}

.day-plan__phone .v-icon {
  color: inherit;
}

.day-plan__period {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--day-plan-edge);
  font-variant-numeric: tabular-nums;
}

.day-plan__current-date {
  font-weight: 600;
}

.day-plan__fact .day-plan__place {
  margin-top: 4px;
  color: var(--day-plan-muted);
}

.day-plan__responsible {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 16px;
}

.day-plan__responsible .v-icon {
  color: var(--day-plan-muted);
}

.day-plan__supplement,
.day-plan__notes {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--day-plan-edge);
}

.day-plan__details .day-plan__equipment {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 20px;
  padding-left: 18px;
}

.day-plan__notes {
  display: grid;
  gap: 12px;
}

.day-plan__notes p {
  margin-bottom: 0;
  white-space: pre-line;
}

.day-plan__condition {
  margin-top: 12px;
}

.day-plan__condition-fields,
.day-plan__condition-error {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.day-plan__condition-field {
  display: grid;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
}

.day-plan__condition-field > .day-plan__muted {
  font-size: 12px;
  line-height: 18px;
}

.day-plan .day-plan__condition .v-btn {
  height: auto;
  min-height: 36px;
  padding: 8px 12px;
  letter-spacing: normal;
  text-transform: none;
}

.day-plan__condition ::v-deep .v-btn__content {
  white-space: normal;
}

.v-list .day-plan__condition-option {
  min-height: 44px;
}

.day-plan__condition-value {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.day-plan--dark .day-plan__condition ::v-deep .brown--text {
  color: #d7a78d !important;
}

.day-plan ::v-deep a:not(.v-btn) {
  color: var(--day-plan-link);
}

.day-plan__actions ::v-deep .secondary--text {
  color: var(--day-plan-muted) !important;
}

.day-plan__actions ::v-deep .light-blue--text {
  color: var(--day-plan-link) !important;
}

.day-plan__event {
  font-weight: 500;
}

.day-plan__event--issue {
  color: var(--day-plan-link);
}

.day-plan__event--return {
  color: var(--day-plan-return);
}

.day-plan ::v-deep .v-timeline::before {
  background: var(--day-plan-edge);
}

@media (max-width: 959px) {
  .day-plan__header {
    padding: 12px;
  }

  .day-plan__summary--right {
    justify-content: flex-start;
  }
}

@media (max-width: 599px), (pointer: coarse) {
  .day-plan__phone,
  .day-plan .day-plan__condition .v-btn,
  .day-plan .day-plan__payment .v-btn {
    min-height: 44px;
  }
}

@media (max-width: 599px) {
  .day-plan ::v-deep .v-timeline--dense:not(.v-timeline--reverse)::before {
    left: 23px;
  }

  .day-plan ::v-deep .v-timeline--dense .v-timeline-item__divider {
    min-width: 48px;
  }

  .day-plan ::v-deep .v-timeline--dense .v-timeline-item__body {
    max-width: calc(100% - 48px);
  }

  .day-plan ::v-deep .v-timeline--dense .v-timeline-item__dot {
    margin-top: 12px;
  }

  .day-plan__panel ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 12px 16px;
  }

  .day-plan__payment {
    margin-left: 0;
  }
}
</style>
